<template>
  <filter-bar
    :visible="showFilters"
  >
    <checkbox-filter
      class="me-3"
      v-model="filters.isActivated"
      name="Actief"
      :options="new Map([
        [true, 'Ja'],
        [false, 'Nee'],
      ])"
    />

    <button-filter
      v-model="displayInvalidUsers"
    >
      Toon niet-geverifieerde gebruikers
    </button-filter>

    <div class="col-3 ms-auto">
      <material-input
        id="app-users-search"
        v-model="searchQuery"
        placeholder="Zoeken..."
        type="search"
      />
    </div>
  </filter-bar>
  
  <template
    v-if="isLoading"
  >
    <div
      v-for="i in 15"
      :key="i"
      class="mt-3 mb-3 col-lg-4 col-md-6"
    >
      <user-card-placeholder
        :key="i"
        :id="i"
        image=""
        :is-activated="true"
        :is-admin="true"
        full-name="Placeholder Placeholder"
        company-name="user.companyName"
        board-member-function="user.boardMemberFunction"
      />
    </div>
  </template>

  <user-list
    v-else
    :users="filteredItems"
  />
</template>

<script>
import { mapActions } from 'vuex';
import { getAll, sendInactiveInvitations } from '@/api/providers/users';

import ButtonFilter from '@/components/UI/ButtonFilter.vue';
import FilterBar from '../../components/UI/FilterBar.vue';
import MaterialInput from '@/components/MaterialInput.vue';
import CheckboxFilter from '@/components/UI/CheckboxFilter.vue';

import initializeSearchBarFocusEvent from '../../helpers/search-bar';
import { getAllUnverified } from '../../api/providers/users';

import UserCardPlaceholder from '../../components/AppUsers/UserCardPlaceholder.vue';
import UserList from '../../components/AppUsers/Index/UserList.vue';

export default {
  name: 'AppUsers',

  components: {
    ButtonFilter,
    CheckboxFilter,
    FilterBar,
    MaterialInput,
    UserCardPlaceholder,
    UserList,
  },

  data: () => ({
    filters: {
      isActivated: [],
    },
    displayInvalidUsers: false,
    items: [],
    unverifiedItems: null,
    searchQuery: '',
    showFilters: false,
    isLoading: true,
  }),

  computed: {
    filteredItems() {
      return this.currentList
        .filter(this.searchFilter)
        .filter(this.filtersFilter);
    },

    currentList() {
      return this.displayInvalidUsers
        ? this.unverifiedItems ?? []
        : this.items;
    },

    lowerCaseSearchTerms() {
      return this.searchQuery.toLowerCase().split(' ');
    },
  },

  mounted() {
    this.loadUsers();
    this.addActions();

    initializeSearchBarFocusEvent(
      () => this.showFilters = true
    );
  },

  watch: {
    displayInvalidUsers(newValue) {
      if (newValue == false) return;
      if (this.unverifiedItems !== null) return;

      this.isLoading = true;
      getAllUnverified()
        .then(users => {
          this.unverifiedItems = users;
          this.isLoading = false;
        })
    },
  },

  methods: {
    ...mapActions('appHeader', [
      'addAction',
    ]),

    ...mapActions('notification', {
      addNotification: 'add',
    }),

    addActions() {
      this.addAction({
        handler: () => this.showFilters = !this.showFilters,
        icon: 'tune',
        text: 'Filters',
      });

      this.addAction({
        handler: this.inviteAll,
        icon: 'forward_to_inbox',
        text: 'Verstuur app-uitnodigingen',
      });

      this.addAction({
        handler: () => this.$router.push({
          name: 'new-app-user',
        }),
        icon: 'person_add',
        text: 'Nieuw',
      });
    },

    filtersFilter(item) {
      return Object.entries(this.filters)
        .every(([property, values]) => (
          values.includes(item[property])
          || !values.length
        ));
    },

    inviteAll() {
      const inactiveAppUsersAmount = (
        this.items
          .filter(({ isActivated }) => !isActivated)
          .length
      );

      if (!inactiveAppUsersAmount) {
        return alert('Er zijn momenteel geen app-gebruikers die geen gebruik maken van de app.');
      }

      if (!confirm(`Wil je ${inactiveAppUsersAmount} inactieve app-gebruiker${inactiveAppUsersAmount > 1 ? 's' : ''} uitnodigen?`)) {
        return;
      }

      sendInactiveInvitations()
        .then(() => {
          this.addNotification({
            description: `Er ${inactiveAppUsersAmount > 1 ? 'zijn' : 'is'} ${inactiveAppUsersAmount} app-uitnodiging${inactiveAppUsersAmount > 1 ? 'en' : ''} verzonden.`,
            icon: {
              component: 'mark_email_read',
            },
          });
        });
    },

    loadUsers() {
      getAll()
        .then((data) => {
          this.items = data;
          this.isLoading = false;
        })
        .catch((error) => error.default());
    },

    removeItem(id) {
      this.items.splice(this.items.findIndex((item) => item.id === id), 1);
    },

    searchFilter(item) {
      return !this.searchQuery.length
        ? true
        : Object.values(item)
            .filter((value) => {
              if (typeof value !== 'string') {
                return false;
              }

              const lowerCaseValue = value.toLowerCase();

              return this.lowerCaseSearchTerms
                .filter(
                  (lowerCaseSearchTerm) => lowerCaseValue.includes(lowerCaseSearchTerm)
                ).length;
            }).length
    },
  },
};
</script>

<style scoped lang="scss">
.filter-bar {
  height: 0;
  transition-property: height margin opacity;
  transition-duration: .2s;

  &:not(&--visible) {
    overflow: hidden;
    opacity: 0;
  }

  &--visible {
    height: 56.19px;
  }
}
</style>
